import { Pipe, PipeTransform } from '@angular/core';

import { listOfAddressesWhichIsAvailableInMobileDevice } from '@src/app/utils/list-of-addresses-which-is-available-in-mobile-device';

/* info: Pipe sprawdza, czy routerName, który przesyłamy w argumencie metody jest dostępny na liscie listOfAddressesWhichIsAvailableInMobileDevice */

@Pipe({
  name: 'ifAddressIsAvailableOnThePhone'
})
export class IfAddressIsAvailableOnThePhonePipe implements PipeTransform {

  transform(value: string | undefined): boolean {
    if (value) {
      const ifAddressIsAvailableInList = listOfAddressesWhichIsAvailableInMobileDevice.some(item => value.includes(item));
      return ifAddressIsAvailableInList;
    }
    return false;
  }

}
